"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelDrawableLinePoint = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var drawable_1 = require("./drawable");
var CollectionModelDrawableLinePoint = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionModelDrawableLinePoint, _super);
    function CollectionModelDrawableLinePoint(collectionModelDrawableState, drawableId, x, y, parentId) {
        var _this = _super.call(this, collectionModelDrawableState, drawableId) || this;
        _this.x = x;
        _this.y = y;
        _this._parentId = parentId;
        return _this;
    }
    CollectionModelDrawableLinePoint.isLinePoint = function (t) {
        return t instanceof CollectionModelDrawableLinePoint;
    };
    /** Lines can only be moved left/right */
    CollectionModelDrawableLinePoint.prototype.move = function (x, y) {
        var bounds = this.getPointInBounds(x, this.y);
        this.x = bounds.x;
        this.y = bounds.y;
    };
    Object.defineProperty(CollectionModelDrawableLinePoint.prototype, "parent", {
        get: function () {
            return this.drawableState.getDrawable(this._parentId);
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelDrawableLinePoint.prototype.remove = function () {
        _super.prototype.remove.call(this);
        // Remove this line-point's parent too, unless it has already been removed
        if (this.drawableState.hasDrawable(this._parentId)) {
            this.parent.remove();
        }
    };
    Object.defineProperty(CollectionModelDrawableLinePoint.prototype, "isInsightMeasurement", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelDrawableLinePoint.prototype.isApprovableInsightDrawable = function () {
        return false;
    };
    Object.defineProperty(CollectionModelDrawableLinePoint.prototype, "isVisible", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelDrawableLinePoint.prototype.clone = function (newParentDrawableState) {
        return new CollectionModelDrawableLinePoint(newParentDrawableState, this.id, this.x, this.y, this._parentId);
    };
    CollectionModelDrawableLinePoint.prototype.equals = function (other) {
        return (other instanceof CollectionModelDrawableLinePoint
            && this._parentId === other._parentId
            && this.x === other.x
            && this.y === other.y
            && this._equals(other));
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], CollectionModelDrawableLinePoint.prototype, "x", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], CollectionModelDrawableLinePoint.prototype, "y", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], CollectionModelDrawableLinePoint.prototype, "move", null);
    return CollectionModelDrawableLinePoint;
}(drawable_1.MoveableDrawable));
exports.CollectionModelDrawableLinePoint = CollectionModelDrawableLinePoint;
//# sourceMappingURL=line.point.drawable.js.map